import {h, Component} from 'preact';
import Cart from '@components/cart';
import {Query} from 'react-apollo';
import {GetCart} from '@services/CartService/query.graphql';

function getLineItemQuantityCount ( lineItems ) {
    if ( !Array.isArray( lineItems ) ) {
        return null;
    }

    return lineItems.reduce( ( acc, next ) => (acc += parseInt( next.quantity, 10 ) || 0), 0 );
}

const MiniCartSummary = () =>
    <Query query={GetCart}>
        {( {data} ) => {
            const cartItemCount = data && data.cart ? getLineItemQuantityCount( data.cart.lineItems ) : null;
            return <Cart.Header cartItemCount={cartItemCount}/>
        }}
    </Query>;

export default MiniCartSummary;
